import classNames from "classnames";
import useAccordionItemContext from "../use-accordion-item-context";
import ExpandCollapseArrows from "../../expand-collapse-arrows";

import { doNothing } from "@edgetier/utilities";
import "./accordion-item-header.scss";
import { IProps } from "./accordion-item-header.types";

/**
 * Clickable header for an accordion item. Clicking it should open the item.
 * @param props.children Header content.
 * @param props.clickOnIconOnly If true, only the icon will be clickable.
 * @param props.hideArrow If true, the expand/collapse arrow will not be shown. Default is false.
 * @returns              Header content and icon to show if the content is open or closed.
 */
const AccordionItemHeader = ({ children, className, clickOnIconOnly = false, hideArrow = false }: IProps) => {
    const { canOpen, isOpen, toggleOpen } = useAccordionItemContext();
    // The tabIndex is necessary so the accordion header is focusable.
    return (
        <div
            className={classNames("accordion__accordion-item-header", className, {
                "accordion__accordion-item-header--click-icon-only": clickOnIconOnly,
            })}
            onClick={clickOnIconOnly ? doNothing : toggleOpen}
            tabIndex={0}
        >
            <div className="accordion__accordion-item-header__title">{children}</div>
            {hideArrow ||
                (canOpen && <ExpandCollapseArrows isUp={isOpen} onClick={clickOnIconOnly ? toggleOpen : doNothing} />)}
        </div>
    );
};

export default AccordionItemHeader;
